import api from '@api/Api';

export default {

    getForm(slug, params) {
        return api().get(`/review/${slug}`, { params: params });
    },

    createFormReview(slug, params) {
        return api().post(`/review/${slug}`, params);
    },

    createFormReviewGuest(slug, params) {
        return api().post(`/review/${slug}/guest`, params);
    },

    createFormScore(slug, params) {
        return api().post(`/review/${slug}/score`, params);
    },

    createFormScoreGuest(slug, params) {
        return api().post(`/review/${slug}/score/guest`, params);
    },

    getFields(id) {
        return api().get(`/reviews/${id}/fields`);
    },

    getRelated(id) {
        return api().get(`/reviews/${id}/related`);
    },

    getReview(id) {
        return api().get(`/reviews/${id}`);
    },

    updateReview(id, params) {
        return api().put(`/reviews/${id}`, params);
    },

    updateDetails(id, params) {
        return api().put(`/reviews/${id}/details`, params);
    },

    flagHidden(id, params) {
        return api().put(`/reviews/${id}/flag-hidden`, params);
    },

    flagDuplicate(id, params) {
        return api().put(`/reviews/${id}/flag-duplicate`, params);
    },

    updateFields(id, params) {
        return api().put(`/reviews/${id}/fields`, params);
    },

    createField(id, params) {
        return api().post(`/reviews/${id}/fields`, params);
    },

    deleteField(id) {
        return api().delete(`/reviews/fields/${id}`);
    },

    updateReviewer(id, params) {
        return api().put(`/reviews/${id}/reviewer`, params);
    },

    updateReply(id, params) {
        return api().put(`/reviews/${id}/reply`, params);
    },

    generateReply(id, params) {
        return api().post(`/reviews/${id}/reply/generate`, params);
    },

    deleteReply(id) {
        return api().delete(`/reviews/${id}/reply`);
    },

    deleteReview(id) {
        return api().delete(`/reviews/${id}`);
    },

    previewShare(id, params) {
        return api().get(`/reviews/${id}/share/preview`, { params: params });
    },

    createShare(id, params) {
        return api().post(`/reviews/${id}/share`, params, {
            responseType: 'blob',
        });
    },

}